import Ajv from 'ajv';

// WARNING: react-jsonschema-form only supports local definition referencing,
// so the GeoJSON Point schema must be copied locally

// Copied from https://geojson.org/schema/Point.json
const point = {
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "https://geojson.org/schema/Point.json",
  "title": "GeoJSON Point",
  "type": "object",
  "required": [
    "type",
    "coordinates"
  ],
  "properties": {
    "type": {
      "type": "string",
      "enum": [
        "Point"
      ]
    },
    "coordinates": {
      "type": "array",
      "minItems": 2,
      "items": {
        "type": "number"
      }
    },
    "bbox": {
      "type": "array",
      "minItems": 4,
      "items": {
        "type": "number"
      }
    }
  }
}

/*const location = {
  "$schema": "http://json-schema.org/schema#",
  "$id": "http://airfieldmap.com/schemas/location.json",
  title: "Location",
  type: "object",
  properties: {
    latitude: {
      type: "number",
      minimum: -90,
      maximum: 90
    },
    longitude: {
      type: "number",
      minimum: -180,
      maximum: 180
    }
  },
  required: ["latitude", "longitude"],
  //uniforms: { component: LocationField },
};*/


const radio = {
  "$schema": "http://json-schema.org/schema#",
  "$id": "http://airfieldmap.com/schemas/radio.json",
  title: "Radio",
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    frequency: { // TODO: 3.3 format
      type: "number",
    }
  },
  required: ["name", "frequency"],
  //uniforms: { component: RadioField },
};

const runway = {
  "$schema": "http://json-schema.org/schema#",
  "$id": "http://airfieldmap.com/schemas/runway.json",
  title: "Runway",
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    length: {
      type: "string",
    },
    width: {
      type: "string",
    },
    surface: {
      type: "string",
      enum: ['concrete', 'grass'],
      // TODO: FIXME enumNames was not approved for JSON schema spec https://github.com/rjsf-team/react-jsonschema-form/issues/532
      //enumNames: ['Concrete', 'Grass'],
      /*options: [
        {
          label: 'Concrete',
          value: 'concrete',
        },
        {
          label: 'Grass',
          value: 'grass',
        },
      ],*/
    },
    /*path: {
      type: "?",
    },*/
  },
  required: ["name"],
  //uniforms: { component: RunwayField },
};

export const schema = {
  "$schema": "http://json-schema.org/schema#",
  "$id": "http://airfieldmap.com/schemas/airfield.json",
  title: "Airfield",
  type: "object",
  /*definitions: {
    location: {
      properties: {
        latitude: {
          type: "number",
          minimum: -90,
          maximum: 90
        },
        longitude: {
          type: "number",
          minimum: -180,
          maximum: 180
        }
      }
    }
  },*/
  properties: {
    _id: { type: "string" },
    name: {
      type: "string",
      title: "Name",
      minLength: 1,
      maxLength: 100
    },
    slug: {
      type: "string",
      title: "Slug",
      description: 'Short, unique name for the airfield to use within the URL',
      minLength: 1,
      maxLength: 20
    },
    iata: {
      type: "string",
      title: "IATA",
      minLength: 3,
      maxLength: 3
    },
    icao: {
      type: "string",
      title: "ICAO",
      minLength: 4,
      maxLength: 4
    },

    centroid: point,
    runways: {
      type: "array",
      items: runway
    },
    pictureUrl: {
      type: 'string',
    },
    radio: radio
  },
  required: ["name", "slug", "centroid"],
  //additionalProperties: true
};

export const uiSchema = {
  /*name: {
    classNames: "custom-class-name"
  },
  age: {
    classNames: "custom-class-age"
  },*/

  _id: {"ui:widget": "hidden"}
}


/*
  website: Joi.string()
  fuel: Joi.array().items(Joi.string()),

  links: Joi.array().items({
    type: Joi.string(),
    page: Joi.string(),
    slug: Joi.string(),
    key: Joi.string(),
    id: Joi.number(),
    href: Joi.string().uri(),
  }),

  amenities: Joi.array().items({
    name: Joi.string(),
    href: Joi.string().uri(),
    type: Joi.string()
  }),

  runways: Joi.array()
    .items({
      name: Joi.string(),
      length: Joi.string(),
      width: Joi.string(),
      surface: Joi.string(),
      path: Joi.object()
    })
    .allow(null),


*/

export const ajv = new Ajv({ allErrors: true, useDefaults: true });
//ajv.addSchema(point);
ajv.addVocabulary(['options', 'uniforms', 'enumNames']); // TODO: FIXME